import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../features/auth/ProtectedRoute";
import { LoginPage } from "../features/auth/LoginPage";
import { AppShell } from "../layouts/AppShell";
import { FrontDeskPage } from "../features/front-desk/FrontDeskPage";
import { UsersPage } from "../features/users/UsersPage";
import { ActivityLogsPage } from "../features/activity-logs/ActivityLogsPage";
import { CustomerListPage } from "../features/customers/CustomerListPage";
import { CustomerFormPage } from "../features/customers/CustomerFormPage";
import { CustomerProfilePage } from "../features/customers/CustomerProfilePage";
import { VehicleListPage } from "../features/vehicles/VehicleListPage";
import { VehicleFormPage } from "../features/vehicles/VehicleFormPage";
import { VehicleProfilePage } from "../features/vehicles/VehicleProfilePage";
import { VehicleSpecificationsPage } from "../features/vehicles/VehicleSpecificationsPage";
import { RepairOrderListPage } from "../features/repair-orders/RepairOrderListPage";
import { NewRepairOrderPage } from "../features/repair-orders/NewRepairOrderPage";
import { RepairWorkspacePage } from "../features/repair-orders/RepairWorkspacePage";
import { InputStandardsTestPage } from "../features/system/InputStandardsTestPage";
import { TechnicianQueuePage } from "../features/workshop/TechnicianQueuePage";
import { PilotValidationPage } from "../features/pilot-validation/PilotValidationPage";
import { InventoryTestPage } from "../features/operations/InventoryTestPage";
import { PurchaseTestPage } from "../features/operations/PurchaseTestPage";
import { ReportsTestPage } from "../features/operations/ReportsTestPage";
import { RolesPage } from "../features/roles/RolesPage";
import { RequiredPasswordChangePage } from "../features/auth/RequiredPasswordChangePage";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/change-password" element={<RequiredPasswordChangePage />} />
          <Route element={<AppShell />}>
            <Route index element={<FrontDeskPage />} />
            <Route path="/customers" element={<CustomerListPage />} />
            <Route path="/customers/new" element={<CustomerFormPage />} />
            <Route path="/customers/:id" element={<CustomerProfilePage />} />
            <Route path="/customers/:id/edit" element={<CustomerFormPage />} />
            <Route path="/vehicles" element={<VehicleListPage />} />
            <Route path="/vehicles/new" element={<VehicleFormPage />} />
            <Route path="/vehicles/:id" element={<VehicleProfilePage />} />
            <Route path="/vehicles/:id/edit" element={<VehicleFormPage />} />
            <Route path="/vehicles/:id/specifications" element={<VehicleSpecificationsPage />} />
            <Route path="/repair-orders" element={<RepairOrderListPage />} />
            <Route path="/workshop" element={<TechnicianQueuePage />} />
            <Route path="/inventory" element={<InventoryTestPage />} />
            <Route path="/purchase" element={<PurchaseTestPage />} />
            <Route path="/reports" element={<ReportsTestPage />} />
            <Route path="/repair-orders/new" element={<NewRepairOrderPage />} />
            <Route path="/repair-orders/:id/workspace" element={<RepairWorkspacePage />} />
            <Route path="/repair-orders/:id/workspace/:section" element={<RepairWorkspacePage />} />
            <Route path="/access/users" element={<UsersPage />} />
            <Route path="/access/roles" element={<RolesPage />} />
            <Route path="/system/activity-logs" element={<ActivityLogsPage />} />
            <Route path="/system/input-standards-test" element={<InputStandardsTestPage />} />
            <Route path="/system/pilot-validation" element={<PilotValidationPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
